import ReactOnRails from 'react-on-rails/client';
import BuilderView from '../../components/ror_components/BuilderView.jsx';

ReactOnRails.register({BuilderView});